// Pure helper for the billing block text, shared by the banner and the Generate failure toast.

export const SALES_EMAIL = "info@lucashealth.ai";

// What to tell the user about a plan that reports a billing block, or null when it reports none. The admin's own
// message (admin Subscription tab) always wins; otherwise the default follows the subscription status.
// `canRenew` is whether this user can reach My Plan (supervisors only).
export function billingBlockText(plan, canRenew, t) {
  if (plan?.billingMessage) return plan.billingMessage;
  if (!plan?.subscriptionLapsed) return null;
  return t(canRenew ? "subscriptionLapsed.message" : "subscriptionLapsed.askAdmin", { email: SALES_EMAIL });
}
